<template>
  <div class="filters" ref="filtersWrapper">
    <a-popover
      placement="bottom"
      overlayClassName="filters-popover"
      trigger="click"
      v-model:open="visible"
      @openChange="handleOpen"
      :getPopupContainer="() => $refs.filtersWrapper"
    >
      <artmisads-select-button
        showFilterIcon="true"
        :filterNum="filtersNum"
        showDownIcon="true"
        >{{ $t('seller.brandsPage.filters') }}
      </artmisads-select-button>
      <template #content>
        <div class="filters-down" ref="filtersDown">
          <div class="filters-name">{{ $t('seller.brandsPage.filterStatus') }}</div>
          <artmisads-select
            class="width100"
            v-model:value="filters.status"
            @change="handleChange($event, 'status')"
            :getPopupContainer="() => $refs.filtersDown"
          >
            <a-select-option value="all">{{ $t('seller.common.all') }}</a-select-option>
            <a-select-option value="active">{{ $t('seller.common.active') }}</a-select-option>
            <a-select-option value="inactive">{{ $t('seller.common.inactive') }}</a-select-option>
          </artmisads-select>
          <div class="filters-name">{{ $t('seller.brandsPage.filterCommissionMin') }}</div>
          <div class="commission-number width100">
            <artmisads-input-number
              v-model:value="filters.commission"
              :placeholder="$t('seller.common.pleaseEnter')"
              :step="0.1"
              min="0"
              max="100"
              suffix="%"
              @change="handleChange($event, 'comission')"
            >
            </artmisads-input-number>
          </div>
          <div class="filters-name">{{ $t('seller.brandsPage.filterAvailability') }}</div>
          <div class="width100">
            <artmisads-select
              class="width100"
              v-model:value="filters.availability"
              @change="handleChange($event, 'availability')"
              :getPopupContainer="() => $refs.filtersDown"
            >
              <a-select-option value="all">{{ $t('seller.common.all') }}</a-select-option>
              <a-select-option value="IN_STOCK">{{ $t('seller.brandsPage.inStock') }}</a-select-option>
              <a-select-option value="OUT_OF_STOCK"
                >{{ $t('seller.brandsPage.outOfStock') }}</a-select-option
              >
            </artmisads-select>
          </div>
          <div class="filters-name">{{ $t('seller.brandsPage.filterPrice') }}</div>
          <div class="width100">
            <artmisads-select
              class="width100"
              v-model:value="filters.price"
              @change="handleChange($event, 'price')"
              :getPopupContainer="() => $refs.filtersDown"
              placement="topRight"
            >
              <a-select-option value="all">{{ $t('seller.common.all') }}</a-select-option>
              <a-select-option value="get10"
                >{{ $t('seller.brandsPage.priceUnder', { symbol: currencySymbol }) }}</a-select-option
              >
              <a-select-option value="get15"
                >{{ $t('seller.brandsPage.priceRange', { symbol: currencySymbol, min: 10, max: 25 }) }}</a-select-option
              >
              <a-select-option value="get25"
                >{{ $t('seller.brandsPage.priceRange', { symbol: currencySymbol, min: 25, max: 50 }) }}</a-select-option
              >
              <a-select-option value="get50"
                >{{ $t('seller.brandsPage.priceRange', { symbol: currencySymbol, min: 50, max: 100 }) }}</a-select-option
              >
              <a-select-option value="get100"
                >{{ $t('seller.brandsPage.priceRange', { symbol: currencySymbol, min: 100, max: 200 }) }}</a-select-option
              >
              <a-select-option value="get200"
                >{{ $t('seller.brandsPage.priceAbove', { symbol: currencySymbol }) }}
              </a-select-option>
            </artmisads-select>
          </div>
          <div class="filters-name">{{ $t('seller.brandsPage.filterDeal') }}</div>
          <artemisads-segmented
            v-model:value="filters.deal"
            @change="handleChange($event, 'deal')"
            :options="dealSegmentOptions"
          />
        </div>
        <div class="btns">
          <a
            @click="reset"
            :class="'reset' + (filtersNum ? '' : ' disabled')"
            href="javascript:;"
          >
            <span style="margin-right: 3px">{{ $t('seller.brandsPage.resetFilters') }}</span
            ><span class="filter-num" v-show="filtersNum">{{ filtersNum }}</span
            ><span style="margin-left: 3px">{{ $t('seller.brandsPage.resetFiltersSuffix') }}</span>
          </a>
          <artmisads-button type="primary" size="middle" @click="onSave"
            >{{ $t('seller.common.confirm') }}</artmisads-button
          >
        </div>
      </template>
    </a-popover>
  </div>
</template>
<script setup name="FilterOptions">
import { ref, reactive, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { CURRENCY_MAPPER } from '@/contants/common'
import { useUserInfoStore } from '~/storeData/index'

const { t, locale } = useI18n()
const store = useUserInfoStore()
const dealSegmentOptions = computed(() => {
  locale.value
  return [
    { label: t('seller.brandsPage.dealOff'), value: 'Off' },
    { label: t('seller.brandsPage.dealAll'), value: 'All' },
    { label: t('seller.brandsPage.dealActive'), value: 'Active' },
    { label: t('seller.brandsPage.dealUpcoming'), value: 'Upcoming' },
  ]
})
const currencySymbol = computed(() => {
  return CURRENCY_MAPPER[store.userInfo.countryCode].currency
})
const emit = defineEmits(['get-data'])
let visible = ref(false)
let filtersNum = ref(0)
let filtersDown = ref()
let filtersWrapper = ref()
let filters = reactive({
  deal: 'Off',
  price: 'all',
  status: 'all',
  commission: null,
  availability: 'all',
})
let filtersOrigi = {
  deal: 'Off',
  price: 'all',
  status: 'all',
  commission: null,
  availability: 'all',
}
let options = []
const prices = [
  {
    lable: 'get10',
    maxPrice: 10,
    minPrice: 0,
  },
  {
    lable: 'get15',
    maxPrice: 25,
    minPrice: 10,
  },
  {
    lable: 'get25',
    maxPrice: 50,
    minPrice: 25,
  },
  {
    lable: 'get50',
    maxPrice: 100,
    minPrice: 50,
  },
  {
    lable: 'get100',
    maxPrice: 200,
    minPrice: 100,
  },
  {
    lable: 'get200',
    maxPrice: null,
    minPrice: 200,
  },
]
const onSave = () => {
  visible.value = false
  let req = { ...filters }
  if (req.price != 'all') {
    prices.forEach((v) => {
      if (v.lable == req.price) {
        req.maxPrice = v.maxPrice
        req.minPrice = v.minPrice
      }
    })
    req.page = 1
  }
  delete req.price
  emit('get-data', req)
}
const handleChange = (e, itemName) => {
  let isMark = options.includes(itemName)
  if (!isMark && e != filtersOrigi[itemName]) {
    options.push(itemName)
    filtersNum.value++
  }
  if (isMark && e == filtersOrigi[itemName]) {
    let index = options.findIndex((item) => item == itemName)
    options.splice(index, 1)
    if (filtersNum) {
      filtersNum.value--
    }
  }
  if (itemName == 'comission') {
    filters.commission = e

    if (isNaN(parseFloat(e))) {
      filters.commission = undefined
      return
    }

    filters.commission = Math.floor(e * 10) / 10
  }
}
const reset = () => {
  visible.value = false
  let _filters = {
    deal: 'Off',
    price: 'all',
    status: 'all',
    commission: null,
    availability: 'all',
  }
  options = []
  Object.assign(filters, _filters)
  filtersNum.value = 0

  emit('get-data', {})
}
</script>
<style lang="less" scoped>
@import '../../../../assets/less/filter-popup.less';

.filters {
  :deep(.ant-popover-arrow) {
    left: auto;
    right: 73px;
  }

  .artemisads-segmented {
    width: 100%;

    :deep(.ant-segmented-group) {
      width: 100%;
      justify-content: space-between;
    }
  }

  :deep(.ant-input-number-handler-wrap) {
    opacity: 1 !important;
  }
}
</style>
